import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import { Bogle_Regular, Bogle_Light } from 'constants/constant';

const { LIGHT_GREY, LIGHTER_GREY, PURPLE, FONT_COLOR, GREY, WHITE, BLACK, DARK_PURPLE } = colors;

const Styles = makeStyles(() => ({
	itemContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'start'
	},
	title: {
		fontFamily: 'Bogle-Regular',
		fontSize: '20px',
		color: FONT_COLOR,
		display: 'flex',
		alignItems: 'center'
	},
	descrption: {
		fontFamily: 'Bogle-Light',
		fontSize: '16px',
		color: FONT_COLOR,
		textAlign: 'left',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		display: '-webkit-box',
		wordWrap: 'break-word',
		'-webkit-line-clamp': 3,
		'-webkit-box-orient': 'vertical',
		paddingTop: 16
	},
	activeBorder: {
		borderRadius: '8px',
		height: '110px',
		padding: 24,
		position: 'relative',
		'&:hover': {
			cursor: 'pointer'
		},
		border: `1px solid ${PURPLE}`
	},
	inActiveBorder: {
		borderRadius: '8px',
		position: 'relative',
		height: '110px',
		padding: 24,
		'&:hover': {
			cursor: 'pointer'
		},
		border: `1px solid ${LIGHT_GREY}`
	},
	cardContainer: {
		padding: '0px 30px 0px 30px',
		gap: 24
	},
	minWidthCard: {
		minWidth: 386,
		maxWidth: 400,
		['@media (max-width:400px)']: {
			maxWidth: 360,
			minWidth: 328
		}
	},
	gridContainer: {
		paddingLeft: 30,
		['@media (max-width:600px)']: {
			paddingLeft: 0,
			width: '100%',
			margin: 0,
			justifyContent: 'center'
		}
	},
	tag: {
		alignItems: 'center',
		display: 'flex',
		fontFamily: 'Bogle-Regular !important',
		color: PURPLE,
		padding: '0 8px',
		overflow: 'hidden',
		position: 'absolute',
		inset: '0 0 auto auto'
	},
	charterOnlyHeader: {
		marginLeft: '32px',
		marginTop: '24px',
		marginBottom: '16px',
		fontSize: '18px',
		fontWeight: '700'
	},
	charterOnlyText: {
		color: PURPLE
	},
	checkbox: {
		marginRight: '5px',
		// marginLeft: '26px',
		color: GREY,
		padding: '0 !important',
		'&:hover': {
			backgroundColor: 'unset !important'
		},
		'& .MuiSvgIcon-root': {
			height: '16px',
			width: '16px'
		},
		'&.Mui-checked': {
			'&:hover': {
				backgroundColor: 'unset !important'
			},
			color: `${PURPLE} !important`
		}
	},
	saveCheckbox: {
		marginRight: '5px',
		// marginLeft: '26px',
		color: GREY,
		padding: '0 !important',
		'&:hover': {
			backgroundColor: 'unset !important'
		},
		'& .MuiSvgIcon-root': {
			height: '18px',
			width: '18px'
		},
		'&.Mui-checked': {
			'&:hover': {
				backgroundColor: 'unset !important'
			},
			color: `${PURPLE} !important`
		}
	},
	subHeadingTitle: {
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '24px'
	},
	subHeadingTitleDesc: {
		color: GREY,
		display: 'flex',
		fontSize: '12px',
		fontWeight: '400',
		lineHeight: '16px'
	},
	betaBadge: {
		height: `24px !important`,
		marginLeft: 8,
		fontSize: `12px !important`,
		backgroundColor: `${LIGHTER_GREY} !important`,
		'& span': {
			fontFamily: Bogle_Light
		}
	},
	subHeadingLinks: {
		marginLeft: 8,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		'& a': {
			textDecoration: 'none',
			color: PURPLE
		}
	},
	myDatasetCardDesc: {
		paddingTop: 8,
		fontFamily: Bogle_Light,
		fontSize: 14,
		color: GREY,
		textAlign: 'left',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		display: '-webkit-box',
		wordWrap: 'break-word',
		'-webkit-line-clamp': 3,
		'-webkit-box-orient': 'vertical'
	},
	myDatasetCardContent: {
		display: 'flex',
		flexDirection: 'column'
	},
	myDatasetCardTitle: {
		paddingTop: '10px',
		fontFamily: 'Bogle-Regular',
		fontSize: '20px',
		color: FONT_COLOR,
		display: 'flex',
		alignItems: 'center'
	},
	myDatasetCreator: {
		paddingTop: 8,
		color: GREY,
		fontSize: 14
	},
	datasetFiltersContainer: {
		display: 'flex',
		gap: 15,
		width: '100%',
		alignItems: 'Center',
		height: '40px'
	},
	datasetFilterButtons: {
		height: '40px',
		padding: '0 !important',
		textTransform: 'unset !important',
		'& span': {
			margin: '6px 16px'
		}
	},
	selectedDatasetFilterButtons: {
		height: '40px',
		padding: '0 !important',
		border: `1px solid ${BLACK} !important`,
		textTransform: 'unset !important',
		'& span': {
			margin: '6px 16px'
		}
	},
	modalPrimaryButtons: {
		background: `${PURPLE}`,
		borderRadius: '50px  !important',
		height: 40,
		color: `${WHITE} !important`,
		fontSize: '14px',
		fontFamily: `${Bogle_Regular} !important`,
		textTransform: 'none !important',
		'&:hover': {
			background: `${DARK_PURPLE} !important`
		},
		'&.Mui-disabled': {
			color: `${WHITE} !important`,
			backgroundColor: `${LIGHT_GREY} !important`,
			border: 'none !important'
		}
	},
	cancelButton: {
		height: 40,
		fontWeight: '700',
		textTransform: 'none !important',
		borderRadius: '50px  !important',
		marginRight: '8px'
	},
	noItemFoundImageStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)'
	},
	dialogContentContainer: {
		height: '487px',
		overflow: 'hidden',
		paddingBottom: '0px !important',
		borderBottom: '1px solid #E3E4E5'
	},
	clearAllBtn: {
		color: `${PURPLE} !important`,
		'&.Mui-disabled': {
			color: `#BABBBE !important`,
			border: 'none !important'
		}
	},
	saveDatasetWarning: {
		color: '#74767C',
		fontFamily: `${Bogle_Regular}`,
		fontWeight: 400,
		fontSize: '12px',
		padding: '0px 0px 0px 22px'
	},
	dialogActionsContainer: {
		padding: '16px 24px !important'
	},
	clearIcon: {
		cursor: 'pointer'
	},
	searchIcon: {
		color: '#74767C'
	}
}));

export default Styles;
